define('views/modules/help/contact/contact-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    // views
    'views/parts/info-section',
    'views/parts/form/textbox',
    'views/parts/form/textarea',
    'views/modules/help/modals/contact-form-sending-message-modal',
    // templates
    'text!templates/modules/help/contact/contact-form.html',
    // services
    'services/api',
    'services/user',
    'services/i18n'
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr,
    // views
    VInfoSection,
    VTextbox,
    VTextarea,
    VContactFormSendingMessageModal,
    // templates
    TContactForm,
    //services
    API,
    User,
    i18n
) {

    var VContactForm = Backbone.View.extend({
        template: TContactForm,

        events: {
            'click .send-button button': 'onSendAction'
        },

        regions: {
            firstName: ".first-name-input",
            lastName: ".last-name-input",
            totalCoachingEmail: ".totalcoaching-email-input",
            replyTo: ".reply-to-input",
            subject: ".subject-input",
            description: ".description-input"
        },

        initialize: function(opt) {
            opt = opt || {};

            var view = this.view = {
                info: new VInfoSection({
                    title: "Contact Us",
                    help: "messages:helpbox-contact-us",
                    content: this.template
                }),
                subject: new VTextbox({label: 'Subject', labelposition: 'outer', attribute: 'subject'}),
                description: new VTextarea({
                    label: 'Please describe your request',
                    attribute: 'description',
                    labelposition: 'outer',
                    rows: 4
                }),
            };
        },

        render: function() {
            this.assign(this.view.info, this.$el);

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.description, zone.$description)
                .assign(view.subject, zone.$subject);
        },

        sendContactRequest: function() {
            var xmlHttp = new XMLHttpRequest();
            try {
                var urlContactRequest = API.url("contact");
                var view = this.view;
                xmlHttp.open("POST", urlContactRequest, false);
                xmlHttp.setRequestHeader("Content-Type", "application/json");
                xmlHttp.send(JSON.stringify({
                    firstname: User.get('firstname'),
                    lastname: User.get('lastname'),
                    email: User.get('email'),
                    reply_email: User.get('email'),
                    subject: view.subject.getValue(),
                    message: view.description.getValue(),
                }));
                var obj = JSON.parse(xmlHttp.responseText);

                if (obj === true)
                    return true;
                else {
                    //If code field is present, an error occur
                    return obj.hasOwnProperty('code') ? obj.code : false;
                }
            } catch (err) {
                return false;
            }
        },
        ////////////
        // events //
        ////////////
        onSendAction: function() {
            //A little validation
            if (_.isEmpty(this.view.subject.getValue()) || _.isEmpty(this.view.description.getValue())) {
                Toastr.error(
                    i18n.t('conversation:contact_request_error_empty_subject_body'),
                    '', { // These options should be set globally.
                        positionClass: "toast-top-center", // Default = toast-top-right
                        newestOnTop: false, // Default = true
                        showMethod: "slideDown",    // Default = fadeIn
                        tapToDismiss: true,  // Default = false
                        closeButton: true
                    });
                return;
            }

            var messageModal = new VContactFormSendingMessageModal(i18n.t('tutorials:sending_message'));
            messageModal.render();

            //Sending mail.....
            var retVal = this.sendContactRequest();

            if (retVal) {
                messageModal.close();
                Toastr.success(
                    i18n.t('conversation:contact_request_successfully_sending_mail'),
                    '', { // These options should be set globally.
                        positionClass: "toast-top-center", // Default = toast-top-right
                        newestOnTop: false, // Default = true
                        showMethod: "slideDown",    // Default = fadeIn
                        tapToDismiss: true,  // Default = false
                        closeButton: true
                    });
            } else {
                messageModal.close();
                Toastr.error(
                    i18n.t('conversation:contact_request_error_sending_mail'),
                    retVal, { // These options should be set globally.
                        positionClass: "toast-top-center", // Default = toast-top-right
                        newestOnTop: false, // Default = true
                        showMethod: "slideDown",    // Default = fadeIn
                        tapToDismiss: true,  // Default = false
                        closeButton: true
                    });
            }
        },

    });

    return VContactForm;

});

